import newborns from "./newborns";
import lang from "../../lib/appfuse-react/core/lang";

const newbornService = [{
    matcher: 'newborns',
    reply: (config) => {
        if(config.method==='post') {
            return [200, newborns[0]];
        } else {
            const {predicate} = config.params;
            let data;
            const selector = predicate?.node()?.selector?.();
            const children = predicate?.node()?.children?.();
            if (lang.isNotEmpty(selector)) {
                const value = predicate.node().expectation();
                if(lang.isEmpty(value)) {
                    return [200, newborns];
                }
                if (selector === 'motherName') {
                    const regexp = new RegExp(value.replaceAll('*', '.*'));
                    data = newborns.filter(newborn => regexp.test(newborn[selector]));
                } else if(predicate.node().operator() === '==') {
                    data = newborns.filter(newborn => newborn[selector]===value)
                } else if (predicate.node().operator() === '=ge=') {
                    const type = selector.replaceAll('Start', '');
                    data = newborns.filter(newborn => newborn[type] >= value);
                } else if (predicate.node().operator() === '=le=') {
                    const type = selector.replaceAll('End', '');
                    data = newborns.filter(newborn => newborn[type] <= value);
                }
            } else if(lang.isNotEmpty(children)) {
                let tmp = newborns;
                for(let child of children) {
                    const value = child.expectation();
                    if(lang.isEmpty(value)) {
                        continue;
                    }
                    const operator = child.operator();
                    const selector = child.selector();
                    if(selector === 'motherName') {
                        const regexp = new RegExp(value.replaceAll('*', '.*'));
                        tmp = tmp.filter(newborn => regexp.test(newborn[selector]));
                    } else if(operator === '==') {
                        tmp = tmp.filter(newborn => newborn[selector]===value);
                    } else if (operator === '=ge=') {
                        const type = selector.replaceAll('Start', '');
                        tmp = tmp.filter(newborn => newborn[type] >= value);
                    } else if (operator === '=le=') {
                        const type = selector.replaceAll('End', '');
                        tmp = tmp.filter(newborn => newborn[type] <= value);
                    }
                }
                data = tmp;
            } else {
                data = newborns;
            }
            return [200, data];
        }
    }
}, {
    matcher: /newborns\/(.*)/,
    reply: config => {
        const id = /newborns\/(.*)/.exec(config.url)[1];
        const newborn = newborns.find(newborn => newborn.no === id);
        return [200, newborn];
    }
}];

export default newbornService;